export const authTranslations = [
  'common.email',
  'common.login',
  'common.register',
  'common.password',

  'pages.login.signIn',
  'pages.register.newPassword',
  'pages.register.choosePassword',
  'pages.register.changePassword',
  'pages.login.forgotPassword',
  'toast.forgotPassword.success',
  'pages.forgotPassword.requestResetMail',
  'pages.forgotPassword.forgotMyPassword',

  'toast.register.forgotPassword.success',
  'toast.register.success',
  'toast.register.fail',
  'toast.common.fail',
  'toast.login.invalid',
];

export const languageFallbackConfigKey = 'languageFallbackConfig';
